import { getBaseUrl } from "./getBaseUrl";

interface CallApi {
  path: string;
  method?: string;
  payload?: any;
  transferId?: string;
  energyServiceFlag?: string;
  xIsonCustomerToken?: string;
}

interface GetOptions {
  method: string;
  payload: string;
  transferId?: string;
  energyServiceFlag?: string;
  xIsonCustomerToken?: string;
}

export class ErrorBase extends Error {
  msgId: string;
  status?: number;
  redirectUrl: string;
  data?: { name: string; plantId: string }[];

  constructor(
    message: string,
    {
      msgId,
      status,
      redirectUrl,
      data,
    }: {
      msgId: string;
      status?: number;
      redirectUrl: string;
      data?: { name: string; plantId: string }[];
    },
  ) {
    super(message);
    this.msgId = msgId;
    this.status = status;
    this.name = "ErrorBase";
    this.redirectUrl = redirectUrl;
    this.data = data;
  }
}

const getOptions = ({
  method,
  payload,
  transferId,
  energyServiceFlag,
  xIsonCustomerToken,
}: GetOptions) => {
  const headers = new Headers({ "Content-Type": "application/json" });

  if (transferId) {
    headers.append("TRANSFER-ID", transferId);
  }

  if (energyServiceFlag) {
    headers.append("Energy-Service-Flag", energyServiceFlag);
  }

  if (xIsonCustomerToken) {
    headers.append("X-ISON-CUSTOMER-TOKEN", xIsonCustomerToken);
  }

  return !payload
    ? {
        method,
        headers,
      }
    : {
        method,
        headers,
        body: JSON.stringify(payload),
      };
};

export const callApi = async <T>({
  path,
  method = "GET",
  payload,
  transferId,
  energyServiceFlag,
  xIsonCustomerToken,
}: CallApi): Promise<T> => {
  const url = getBaseUrl(path);

  try {
    const options = getOptions({
      method,
      payload,
      transferId,
      energyServiceFlag,
      xIsonCustomerToken,
    });
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorJson = await response.json();
      throw new ErrorBase(
        errorJson.message ? errorJson.message : response.statusText,
        {
          msgId: errorJson.msgId,
          status: response.status,
          redirectUrl: errorJson.redirectUrl,
          data: errorJson.data,
        },
      );
    } else {
      const responseStr = await response.text();
      const responseJson = responseStr === "" ? {} : JSON.parse(responseStr);
      return responseJson;
    }
  } catch (e) {
    const error = e as Error;
    throw error;
  }
};

const getOptionsLeadTransfer = ({ method }: GetOptions) => {
  const headers = new Headers();
  return {
    method,
    headers,
  };
};

export const callLeadTransfer = async <T>({
  path,
  method = "GET",
  payload,
  transferId,
  energyServiceFlag,
}: CallApi): Promise<T> => {
  const url = getBaseUrl(path);

  try {
    const options = getOptionsLeadTransfer({
      method,
      payload,
      transferId,
      energyServiceFlag,
    });
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorJson = await response.json();
      throw new ErrorBase(
        errorJson.message ? errorJson.message : response.statusText,
        {
          msgId: errorJson.msgId,
          status: response.status,
          redirectUrl: errorJson.redirectUrl,
        },
      );
    } else {
      const responseStr = await response.text();
      const responseJson = responseStr === "" ? {} : JSON.parse(responseStr);
      return responseJson;
    }
  } catch (e) {
    const error = e as Error;
    throw error;
  }
};
